import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { modalPrimaryButtonStyle } from '../styles/buttonStyles'

const ServerUnavailableModal = ({ open, onClose }) => {
  const { t } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  useEffect(() => {
    if (!open) {
      setHoverBtn(null)
      setPressedBtn(null)
    }
  }, [open])

  if (!open) return null

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#122629',
          padding: 20,
          border: '2px solid #107c6b',
          borderRadius: 12,
          boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
          width: 'clamp(320px, 30vw, 420px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            width: '100%',
            alignItems: 'center',
            marginBottom: 24,
            textAlign: 'center'
          }}
        >
          <p
            style={{
              fontSize: 20,
              margin: 0,
              color: '#d9ffe4'
            }}
          >
            {t('SERVER-ERROR')}
          </p>
        </div>

        <button
          style={modalPrimaryButtonStyle(
            pressedBtn,
            'close',
            hoverBtn === 'close'
          )}
          onMouseEnter={() => setHoverBtn('close')}
          onMouseLeave={() => {
            setHoverBtn(null)
            setPressedBtn(null)
          }}
          onMouseDown={() => setPressedBtn('close')}
          onMouseUp={() => setPressedBtn(null)}
          onClick={onClose}
        >
          {t('CLOSE')}
        </button>
      </div>
    </div>
  )
}

export default ServerUnavailableModal